module.exports = __webpack_public_path__ + "static/media/shoper_logo.a1948c5e.png";